import { useAccountConfig } from '@/vue/store/useAccountConfig';
import { DynamicFilterConfig } from '@/interfaces/DynamicFilterConfig';
import { DynamicFilterController } from '@/modules/DynamicFilterController';

declare const window: any;
const { accountConfig } = useAccountConfig();
const {$} = window;
window.hasExpEditPanel = true;

export default function ExpEdit(id) {
    this.id = id;
    this.$outer = $(`#${  id}`);
    this.$fields = null;
    this.reset = false;
    this.numChangedElems = 0;
    this.unloadConfirmationTimer = null;

    this.fieldMap = {};
    this.isInitialized = false;

    //Methods
    this.sanitizeInputText = window.debounce(function($input) {
        const val = window.stripAllMarkup($input.val());
        if (val.length < $input.val().length) {
            // update val if characters were stripped
            $input.val(val);
        }
    }, 150);

    this.attachEvents = function(context) {
        this.$outer
            .off('.expedit-sanitize')
            .off('.expedit-checkvalues')
            .on('keyup.expedit-sanitize', 'input[type="text"]', function() {
                context.sanitizeInputText($(this));
            })
            .on('keyup.expedit-sanitize', 'textarea', function() {
                context.sanitizeInputText($(this));
            })
            .on('keyup.expedit-checkvalues blur.expedit-checkvalues change.expedit-check-values', '.js-expedit-field', function(e) {
                context.checkValueChanged(this);
            });
    };

    this.cacheSelectors = function() {
        this.$outer = $(`#${  id}`);
        this.$outer.find('input').not('[type=submit]').addClass('js-expedit-field');
        this.$outer.find('select').addClass('js-expedit-field');
        this.$outer.find('textarea').addClass('js-expedit-field');
        this.$fields = this.$outer.find('.js-expedit-field');
    };

    this.checkValueChanged = window.debounce(function(elem) {
        const d = this.fieldMap[elem.id];
        
        // Ensure the field exists in fieldMap before accessing its properties
        if (!d) {
            // Field not in fieldMap, return
            return;
        }
        
        // if this is the first time we are recognizing this field as changed...
        if (d.originalValue !== elem.value) {
            if (!d.isChanged) {
                d.isChanged = true;
                this.numChangedElems++;
                window.onbeforeunload = function() {
                    return 'Changes you made may not be saved'; 
                };
            }
            return;
        }

        // if we have reverted to original value from a changed value...
        if (d.originalValue === elem.value && d.isChanged) {

            d.isChanged = false;
            this.numChangedElems--;
            if (this.numChangedElems === 0) {
                window.onbeforeunload = null;
            }
            return;
        }
    }, 300);

    this.setFieldMap = function() {
        // save a reference to each fields original value so we can check
        // if it has changed even after a partial postback
        const that = this;
        this.$fields.each(function() {
            if (!that.fieldMap[this.id]) {
                that.fieldMap[this.id] = {
                    originalValue: this.value,
                    isChanged: false
                };
            }
        });
    };

    this.init = function() {
        const that = this;
        this.cacheSelectors();

        if (this.reset) {
            this.fieldMap = {};
            this.numChangedElems = 0;
        }

        this.setFieldMap();
        this.attachEvents(that);

        accountConfig.DynamicFilterConfig?.forEach((config:DynamicFilterConfig) => {
            new DynamicFilterController(config).init();
        });


        // this timer is meant to detach the unsaved changes prompt in event of a session timeout.
        // it will be attached later, so clear it here in case it has been set already.
        clearTimeout(that.clearPromptTimer);

        // check if each field changed after partial postback
        // because data from a receipt may have been added.
        if (this.reset) {
            this.numChangedElems = 0;
        } else {
            this.$fields.each(function() {
                that.checkValueChanged(this);
            });
        }

        this.clearPromptTimer = setTimeout(function() {
            window.onbeforeunload = null;
        }, (60000 * 59));

        this.reset = false;

        if (!this.isInitialized) {
            window.prm.erQueue.add('init', that);
            this.isInitialized = true;
        }
    };
}
